module.exports = __webpack_public_path__ + "img/graphImg05.60968d66.png";